import * as React from 'react'
import {LinkButton} from '@components/common/base/buttons'

export interface TagItemProps {
  text: string
  onClick?: () => void
}

export const TagItem = ({text, onClick}: TagItemProps) => {
  return (
    <LinkButton
      style={{textDecoration: 'underline dashed'}}
      noPaddings
      onClick={onClick}
    >
      {text}
    </LinkButton>
  )
}
